import React from "react";
import "./CheckAdd.scss";
import {withErrorBoundary} from "../../../components/ErrorBoundary";
import {useTranslation} from "react-i18next";
import CheckForm from "../CheckForm/CheckForm";
import useCheckForm from "../hooks/useCheckForm";

const CheckAdd = () => {
  const {Prompt, form, formConfig} = useCheckForm();
  const {t} = useTranslation();

  return (
    <CheckForm
      isAddMode
      header={t("card.title.check.add", "Add check")}
      Prompt={Prompt}
      {...form}
      {...formConfig}
    />
  );
};

export default withErrorBoundary(CheckAdd);